import useAppSelector from '@/hooks/useAppSelector'
import { selectClientMetadata } from '@/redux/slices/clientMetadata'

export function useClientMetadata() {
  return useAppSelector(selectClientMetadata)
}
